import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const BoardItalicIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M5 23L5.588 20.165H8.532L11.935 3.839H8.991L9.579 1H19L18.412 3.839H15.468L12.065 20.165H15.009L14.421 23H5Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

BoardItalicIcon.displayName = 'BoardItalicIcon';
